import gql from 'graphql-tag';
import { DEAL_SHEET_CONFIGURATION_FRAGMENT } from './configurationFragment';

export const CREATE_DEAL_SHEET_CONFIGURATION = gql`
  mutation CreateDealSheetConfig($input: CreateDealSheetConfigurationInput!) {
    dealSheet {
      result: createConfiguration(input: $input) {
        error
        success
        entity {
          ...DealSheetConfig
        }
      }
    }
  }
  ${DEAL_SHEET_CONFIGURATION_FRAGMENT}
`;
